import React from 'react';
import { useDataLegends } from "./legendContext";
import Label from "components/general/Label";
import useViewport from "components/general/useViewPort";

export const LegendsBox = () => {
    const state = useDataLegends();
    const { breakPoint } = useViewport();
    const isMobile = breakPoint === "sm" || breakPoint === "xs"

    if (!Array.isArray(state?.legends?.data) || state?.legends?.data?.length === 0) {
        return <></>
    }

    let legends = state?.legends?.data?.sort((a, b) => {
        if (a.id < b.id) {
            return -1
        } else if (a.id > b.id) {
            return 1
        }
        return 0
    });

    if (isMobile) {
        legends = legends?.filter(item => !item?.hideLegendMobile)
    }
    if (!Array.isArray(legends) || legends?.length === 0) {
        return <></>;
    }


    //group legends 
    const legendsGrouped = groupBy(legends, "id")
    let legendsGroupedUnique = []
    //get uniques values 
    for (const [key, value] of Object.entries(legendsGrouped)) {
        legendsGroupedUnique.push(value[0])
    }

    const showHeader = !legends?.some(l => l?.hideHeader)
    return (
        <div className="legend-container">
            {showHeader && <div className="legend-title"><Label data={'LabelLegend'} /> </div>}
            <div className="legend-content">
                <ul>
                    {legendsGroupedUnique?.map(item => {
                        return (
                            <li key={item?.id} >
                                <span className={item?.id?.length > 4 ? 'legend-id-rules' : 'legend-id'}>{item?.icon || item?.id}:</span>
                                <span className="legend-value"> {item?.name}</span>
                            </li>
                        )
                    })}
                </ul>
            </div>
        </div>

    )
}


const groupBy = (items, key) => items.reduce(
    (result, item) => ({
        ...result,
        [item[key]]: [
            ...(result[item[key]] || []),
            item,
        ],
    }),
    {},
);


